import { Box, Typography, SxProps, Theme } from "@mui/material";

interface StepTimelineProps {
  steps: {
    icon?: React.ReactNode;
    title: string;
    description: React.ReactNode;
    caption?: string;
    color?: "primary" | "success" | "warning" | "info";
  }[];
  sx?: SxProps<Theme>;
}

const colorMap = {
  primary: "#007bff",
  success: "#28a745",
  warning: "#ffc107",
  info: "#17a2b8",
};

export const StepTimeline = ({ steps, sx }: StepTimelineProps) => {
  return (
    <Box sx={{ ...flowTimelineContainerSx, ...sx } as SxProps<Theme>}>
      {steps.map((step, index) => (
        <Box key={index} sx={flowStepSx}>
          <Box sx={{ ...arrowIconSx, backgroundColor: colorMap[step.color || "primary"] }}>
            {step.icon ? (
              step.icon
            ) : (
              <Typography variant="h4" sx={{ fontWeight: 700, fontSize: "2rem" }}>
                {index + 1}
              </Typography>
            )}
          </Box>
          <Box sx={textContainerSx}>
            <Typography variant="h4" sx={flowStepTitleSx}>
              {step.title}
            </Typography>
            <Typography variant="body2" sx={flowStepDescriptionSx}>
              {step.description}
            </Typography>
            {step.caption && (
              <Typography variant="caption" sx={{ color: "#007bff", fontWeight: 600, fontSize: "0.85rem" }}>
                {step.caption}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

const flowTimelineContainerSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  width: "100%",
};

const flowStepSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
};

const arrowIconSx: SxProps<Theme> = {
  width: "96px",
  height: "120px",
  backgroundImage: "linear-gradient(135deg, #fff4 0%, #fff0 50%, #0004 100%)",
  clipPath: "polygon(0% 0%, 50% 15%, 100% 0%, 100% 85%, 50% 100%, 0% 85%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  position: "relative",
  color: "#ffffff",
  boxShadow: "0 10px 24px rgba(25, 118, 210, 0.28)",
  transition: "transform 200ms ease, box-shadow 200ms ease, background-position 300ms ease",
  backgroundSize: "200% 200%",
  backgroundPosition: "0% 50%",
  "@media (max-width: 600px)": {
    width: "72px",
    height: "90px",
  },
};

const textContainerSx: SxProps<Theme> = {
  marginLeft: "20px",
  flex: 1,
};

const flowStepTitleSx: SxProps<Theme> = {
  fontSize: "1.2rem",
  marginBottom: "8px",
  color: "#1a1a2e",
  fontWeight: 600,
};

const flowStepDescriptionSx: SxProps<Theme> = {
  fontSize: "1rem",
  color: "#666",
  lineHeight: 1.5,
};
